import React, {useMemo} from 'react';
import {useLocation} from 'wouter';
import Weekday from "./Weekday";
import {getTimes} from "../../lib/TimeSlotHelper";
import moment from "moment";
import {useQuery} from "urql";
import { readOnePublicRoomQuery, readOneRoom, readPublicWeekdays, readSeasonalWeekdays } from '../../lib/graphql/queries'
import TimeContextProvider from "./context/TimeContext";

const WeekdayProvider = ({ roomID, year, week, isPublic }) => {
  const [, setLocation] = useLocation();

  const showListView = () => {
    setLocation('../../liste/');
  }

  const [roomResult] = useQuery({
    query: isPublic ? readOnePublicRoomQuery : readOneRoom,
    variables: {
      id: roomID
    },
    pause: !roomID
  })

  const roomData = useMemo(() => {
    return roomResult.data?.[isPublic ? 'readOnePublicRoom' : 'readOneRoom']
  }, [isPublic, roomResult.data])

  const [weekdaysResult, refetchWeekdays] = useQuery({
    query: isPublic ? readPublicWeekdays : readSeasonalWeekdays,
    variables: {
      RoomID: roomID,
      Year: year,
      Week: week,
    },
    pause: !roomID || !year || !week,
    requestPolicy: "cache-and-network"
  })

  // in the public view the grid is extended if weekend bookings are outside of the regular time frame
  const weekdaysData = weekdaysResult.data?.readWeekdays

  const startTime = useMemo(() => {
    const time = isPublic && weekdaysData?.ViewStartTime ? weekdaysData.ViewStartTime : roomData?.StartTime
    return time ? moment(time, 'HH:mm') : null
  }, [isPublic, roomData, weekdaysData])

  const endTime = useMemo(() => {
    const time = isPublic && weekdaysData?.ViewEndTime ? weekdaysData.ViewEndTime : roomData?.EndTime
    return time ? moment(time, 'HH:mm') : null
  }, [isPublic, roomData, weekdaysData])

  const timeSlot = useMemo(() => roomData?.TimeSlot || null, [roomData])

  const times = getTimes(startTime, endTime, timeSlot)

  return (
    <TimeContextProvider>
      <Weekday
        times={times}
        timeSlot={timeSlot}
        days={weekdaysData?.Weekdays || []}
        showListView={showListView}
        dayStartTime={startTime}
        dayEndTime={endTime}
        refetchWeekdays={refetchWeekdays}
        hideListButton={isPublic}
      />
    </TimeContextProvider>
  );
}

WeekdayProvider.propTypes = {}

export default WeekdayProvider;
